import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledDiscardButton = styled(Button)`
  && {
    background-color: ${({ theme }) => theme.colors.background.secondary};
  }
`;

export const StyledDiscardText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
`;
